import { render, staticRenderFns } from "./Gallery.vue?vue&type=template&id=229fda5e"
import script from "./Gallery.vue?vue&type=script&lang=js"
export * from "./Gallery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('229fda5e')) {
      api.createRecord('229fda5e', component.options)
    } else {
      api.reload('229fda5e', component.options)
    }
    module.hot.accept("./Gallery.vue?vue&type=template&id=229fda5e", function () {
      api.rerender('229fda5e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/web-components/community/Gallery.vue"
export default component.exports